import { ORDER_PRODUCT_ROW_HEIGHT } from '../orders.constants';
import {
  GetOrderProductRowHeightParams,
  OrderProductRowGutter,
  OrderProductRowInlineSizes,
  OrderProductRowLayout,
  OrderProductSelectSize,
} from './orderProductsLayout.types';

export const ORDER_PRODUCT_GRID_COLUMN_WIDTH = 64;
export const ORDER_PRODUCT_GRID_STICKY_ACTIONS_WIDTH = 62;
export const ORDER_PRODUCT_GRID_MIN_VISIBLE_COLUMNS = 3;

export const ORDER_PRODUCT_GRID_MIN_WIDTH =
  ORDER_PRODUCT_GRID_MIN_VISIBLE_COLUMNS * ORDER_PRODUCT_GRID_COLUMN_WIDTH +
  ORDER_PRODUCT_GRID_STICKY_ACTIONS_WIDTH;

export const ORDER_PRODUCT_TOTALS_AND_ACTIONS_WIDTH = 114;

export const ORDER_PRODUCT_ROW_HORIZONTAL_PADDING = 14;

export const ORDER_PRODUCT_ROW_INLINE_SIZES: Record<
  Exclude<OrderProductRowLayout, OrderProductRowLayout.MOBILE>,
  OrderProductRowInlineSizes
> = {
  [OrderProductRowLayout.WIDE]: {
    imageAndLabel: 263,
    color: 160,
    deliveryWindow: 160,
    columnGap: 14,
    gridGap: 16,
  },
  [OrderProductRowLayout.CONDENSED]: {
    imageAndLabel: 220,
    color: 160,
    deliveryWindow: 160,
    columnGap: 16,
    gridGap: 12,
  },
  [OrderProductRowLayout.STACKED]: {
    imageAndLabel: 220,
    color: 180,
    deliveryWindow: 180,
    columnGap: 16,
    gridGap: 12,
  },
};

export const getOrderProductInlineLayoutMinWidth = (sizes: OrderProductRowInlineSizes) =>
  sizes.imageAndLabel +
  Math.max(sizes.color, sizes.deliveryWindow) +
  sizes.columnGap * 2 +
  sizes.gridGap +
  ORDER_PRODUCT_GRID_MIN_WIDTH +
  ORDER_PRODUCT_TOTALS_AND_ACTIONS_WIDTH +
  ORDER_PRODUCT_ROW_HORIZONTAL_PADDING;

export const getOrderProductStackedLayoutMinWidth = (sizes: OrderProductRowInlineSizes) =>
  Math.max(
    sizes.imageAndLabel +
      sizes.columnGap +
      Math.max(sizes.color, sizes.deliveryWindow) +
      sizes.columnGap +
      ORDER_PRODUCT_TOTALS_AND_ACTIONS_WIDTH,
    ORDER_PRODUCT_GRID_MIN_WIDTH,
  ) + ORDER_PRODUCT_ROW_HORIZONTAL_PADDING;

export const ORDER_PRODUCT_WIDE_MIN_WIDTH = getOrderProductInlineLayoutMinWidth(
  ORDER_PRODUCT_ROW_INLINE_SIZES[OrderProductRowLayout.WIDE],
);

export const ORDER_PRODUCT_STACKED_MIN_WIDTH = getOrderProductStackedLayoutMinWidth(
  ORDER_PRODUCT_ROW_INLINE_SIZES[OrderProductRowLayout.STACKED],
);

export const ORDER_PRODUCT_SELECT_SIZE_BY_LAYOUT: Record<
  OrderProductRowLayout,
  OrderProductSelectSize
> = {
  [OrderProductRowLayout.WIDE]: {
    width: ORDER_PRODUCT_ROW_INLINE_SIZES[OrderProductRowLayout.WIDE].color,
    height: 24,
  },
  [OrderProductRowLayout.CONDENSED]: {
    width: ORDER_PRODUCT_ROW_INLINE_SIZES[OrderProductRowLayout.CONDENSED].color,
    height: 24,
  },
  [OrderProductRowLayout.STACKED]: {
    width: ORDER_PRODUCT_ROW_INLINE_SIZES[OrderProductRowLayout.STACKED].color,
    height: 28,
  },
  [OrderProductRowLayout.MOBILE]: { height: 32 },
};

export const getOrderProductSelectSizing = (layout: OrderProductRowLayout) => {
  const { width, height } = ORDER_PRODUCT_SELECT_SIZE_BY_LAYOUT[layout];

  return {
    ...(width ? { width } : { flex: 1, minWidth: 0 }),
    '& .MuiButtonBase-root': { height },
  };
};

export const ORDER_PRODUCT_ROW_HEIGHT_BY_LAYOUT: Record<OrderProductRowLayout, number> = {
  [OrderProductRowLayout.WIDE]: ORDER_PRODUCT_ROW_HEIGHT.lgDesktopGrid,
  [OrderProductRowLayout.CONDENSED]: ORDER_PRODUCT_ROW_HEIGHT.smCondensed,
  [OrderProductRowLayout.STACKED]: ORDER_PRODUCT_ROW_HEIGHT.sm,
  [OrderProductRowLayout.MOBILE]: ORDER_PRODUCT_ROW_HEIGHT.xs,
};

export const ORDER_PRODUCT_TOUCH_GRID_ROW_HEIGHT_BY_LAYOUT: Record<OrderProductRowLayout, number> =
  {
    [OrderProductRowLayout.WIDE]: ORDER_PRODUCT_ROW_HEIGHT.lgTouchGrid,
    [OrderProductRowLayout.CONDENSED]: ORDER_PRODUCT_ROW_HEIGHT.smCondensedTouchGrid,
    [OrderProductRowLayout.STACKED]: ORDER_PRODUCT_ROW_HEIGHT.smTouchGrid,
    [OrderProductRowLayout.MOBILE]: ORDER_PRODUCT_ROW_HEIGHT.xsTouchGrid,
  };

export const getOrderProductRowHeight = ({
  layout,
  hasTouchGrid,
}: GetOrderProductRowHeightParams) =>
  hasTouchGrid
    ? ORDER_PRODUCT_TOUCH_GRID_ROW_HEIGHT_BY_LAYOUT[layout]
    : ORDER_PRODUCT_ROW_HEIGHT_BY_LAYOUT[layout];

export const ORDER_PRODUCT_ROW_GUTTER: Record<OrderProductRowLayout, OrderProductRowGutter> = {
  [OrderProductRowLayout.WIDE]: { left: 0.75, right: 1 },
  [OrderProductRowLayout.CONDENSED]: { left: 0.75, right: 1 },
  [OrderProductRowLayout.STACKED]: { left: 0.75, right: 1 },
  [OrderProductRowLayout.MOBILE]: { left: 1, right: 1.5 },
};
